export default {
  _id: "5b8ebc1a51b6f5115f9af5c0",
  type: "form",
  tags: [],
  owner: "5b880606acd5b553f1ad58ea",
  components: [
    {
      autofocus: false,
      input: true,
      tableView: true,
      inputType: "text",
      inputMask: "",
      label: "Customer",
      key: "customer",
      placeholder: "",
      prefix: "",
      suffix: "",
      multiple: false,
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      spellcheck: true,
      validate: {
        required: false,
        minLength: "",
        maxLength: "",
        pattern: "",
        custom: "",
        customPrivate: false
      },
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      type: "textfield",
      labelPosition: "top",
      inputFormat: "plain",
      tags: [],
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Period 1 Start",
      key: "period1Start",
      placeholder: "",
      format: "yyyy-MM-dd",
      enableDate: true,
      enableTime: false,
      defaultDate: "",
      datepickerMode: "day",
      datePicker: {
        showWeeks: true,
        startingDay: 0,
        initDate: "",
        minMode: "day",
        maxMode: "year",
        yearRows: 4,
        yearColumns: 5,
        minDate: null,
        maxDate: null,
        datepickerMode: "day"
      },
      timePicker: {
        hourStep: 1,
        minuteStep: 1,
        showMeridian: true,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true
      },
      protected: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false,
        custom: ""
      },
      type: "datetime",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Period 1 End",
      key: "period1End",
      placeholder: "",
      format: "yyyy-MM-dd",
      enableDate: true,
      enableTime: false,
      defaultDate: "",
      datepickerMode: "day",
      datePicker: {
        showWeeks: true,
        startingDay: 0,
        initDate: "",
        minMode: "day",
        maxMode: "year",
        yearRows: 4,
        yearColumns: 5,
        minDate: null,
        maxDate: null,
        datepickerMode: "day"
      },
      timePicker: {
        hourStep: 1,
        minuteStep: 1,
        showMeridian: true,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true
      },
      protected: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false,
        custom: ""
      },
      type: "datetime",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Period 2 Start",
      key: "period2Start",
      placeholder: "",
      format: "yyyy-MM-dd",
      enableDate: true,
      enableTime: false,
      defaultDate: "",
      datepickerMode: "day",
      datePicker: {
        showWeeks: true,
        startingDay: 0,
        initDate: "",
        minMode: "day",
        maxMode: "year",
        yearRows: 4,
        yearColumns: 5,
        minDate: null,
        maxDate: null,
        datepickerMode: "day"
      },
      timePicker: {
        hourStep: 1,
        minuteStep: 1,
        showMeridian: true,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true
      },
      protected: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false,
        custom: ""
      },
      type: "datetime",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Period 2 End",
      key: "period2End",
      placeholder: "",
      format: "yyyy-MM-dd",
      enableDate: true,
      enableTime: false,
      defaultDate: "",
      datepickerMode: "day",
      datePicker: {
        showWeeks: true,
        startingDay: 0,
        initDate: "",
        minMode: "day",
        maxMode: "year",
        yearRows: 4,
        yearColumns: 5,
        minDate: null,
        maxDate: null,
        datepickerMode: "day"
      },
      timePicker: {
        hourStep: 1,
        minuteStep: 1,
        showMeridian: true,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true
      },
      protected: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false,
        custom: ""
      },
      type: "datetime",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Period 3 Start",
      key: "period3Start",
      placeholder: "",
      format: "yyyy-MM-dd",
      enableDate: true,
      enableTime: false,
      defaultDate: "",
      datepickerMode: "day",
      datePicker: {
        showWeeks: true,
        startingDay: 0,
        initDate: "",
        minMode: "day",
        maxMode: "year",
        yearRows: 4,
        yearColumns: 5,
        minDate: null,
        maxDate: null,
        datepickerMode: "day"
      },
      timePicker: {
        hourStep: 1,
        minuteStep: 1,
        showMeridian: true,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true
      },
      protected: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false,
        custom: ""
      },
      type: "datetime",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Period 3 End",
      key: "period3End",
      placeholder: "",
      format: "yyyy-MM-dd",
      enableDate: true,
      enableTime: false,
      defaultDate: "",
      datepickerMode: "day",
      datePicker: {
        showWeeks: true,
        startingDay: 0,
        initDate: "",
        minMode: "day",
        maxMode: "year",
        yearRows: 4,
        yearColumns: 5,
        minDate: null,
        maxDate: null,
        datepickerMode: "day"
      },
      timePicker: {
        hourStep: 1,
        minuteStep: 1,
        showMeridian: true,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true
      },
      protected: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false,
        custom: ""
      },
      type: "datetime",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "Exported Orders Only",
      dataGridLabel: false,
      key: "exportedOrdersOnly",
      defaultValue: "true",
      protected: false,
      persistent: true,
      hidden: false,
      name: "",
      value: "",
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "checkbox",
      labelPosition: "right",
      hideLabel: false,
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Period 4 Start",
      key: "period4Start",
      placeholder: "",
      format: "yyyy-MM-dd",
      enableDate: true,
      enableTime: false,
      defaultDate: "",
      datepickerMode: "day",
      datePicker: {
        showWeeks: true,
        startingDay: 0,
        initDate: "",
        minMode: "day",
        maxMode: "year",
        yearRows: 4,
        yearColumns: 5,
        minDate: null,
        maxDate: null,
        datepickerMode: "day"
      },
      timePicker: {
        hourStep: 1,
        minuteStep: 1,
        showMeridian: true,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true
      },
      protected: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false,
        custom: ""
      },
      type: "datetime",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Period",
      key: "period",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: 'values = data["periodValues"]'
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Period 4 End",
      key: "period4End",
      placeholder: "",
      format: "yyyy-MM-dd",
      enableDate: true,
      enableTime: false,
      defaultDate: "",
      datepickerMode: "day",
      datePicker: {
        showWeeks: true,
        startingDay: 0,
        initDate: "",
        minMode: "day",
        maxMode: "year",
        yearRows: 4,
        yearColumns: 5,
        minDate: null,
        maxDate: null,
        datepickerMode: "day"
      },
      timePicker: {
        hourStep: 1,
        minuteStep: 1,
        showMeridian: true,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true
      },
      protected: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false,
        custom: ""
      },
      type: "datetime",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      inputType: "text",
      inputMask: "",
      label: "Sold To",
      key: "billTo",
      placeholder: "",
      prefix: "",
      suffix: "",
      multiple: false,
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      spellcheck: true,
      validate: {
        required: false,
        minLength: "",
        maxLength: "",
        pattern: "",
        custom: "",
        customPrivate: false
      },
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      type: "textfield",
      labelPosition: "top",
      inputFormat: "plain",
      tags: [],
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Sales Group",
      key: "salesGroup",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: "values = data['salesGroupValues']"
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      inputType: "text",
      inputMask: "",
      label: "Key Account Group",
      key: "keyAccountGroup",
      placeholder: "",
      prefix: "",
      suffix: "",
      multiple: false,
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      spellcheck: true,
      validate: {
        required: false,
        minLength: "",
        maxLength: "",
        pattern: "",
        custom: "",
        customPrivate: false
      },
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      type: "textfield",
      labelPosition: "top",
      inputFormat: "plain",
      tags: [],
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      inputType: "text",
      inputMask: "",
      label: "Ship ID",
      key: "shipID",
      placeholder: "",
      prefix: "",
      suffix: "",
      multiple: false,
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      spellcheck: true,
      validate: {
        required: false,
        minLength: "",
        maxLength: "",
        pattern: "",
        custom: "",
        customPrivate: false
      },
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      type: "textfield",
      labelPosition: "top",
      inputFormat: "plain",
      tags: [],
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      inputType: "text",
      inputMask: "",
      label: "Dealer",
      key: "shipTo",
      placeholder: "",
      prefix: "",
      suffix: "",
      multiple: false,
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      spellcheck: true,
      validate: {
        required: false,
        minLength: "",
        maxLength: "",
        pattern: "",
        custom: "",
        customPrivate: false
      },
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      type: "textfield",
      labelPosition: "top",
      inputFormat: "plain",
      tags: [],
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      inputType: "text",
      inputMask: "",
      label: "Ship State",
      key: "shipState",
      placeholder: "",
      prefix: "",
      suffix: "",
      multiple: false,
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      spellcheck: true,
      validate: {
        required: false,
        minLength: "",
        maxLength: "",
        pattern: "",
        custom: "",
        customPrivate: false
      },
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      type: "textfield",
      labelPosition: "top",
      inputFormat: "plain",
      tags: [],
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      inputType: "text",
      inputMask: "",
      label: "Ship Zip Code",
      key: "shipZipcode",
      placeholder: "",
      prefix: "",
      suffix: "",
      multiple: false,
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      spellcheck: true,
      validate: {
        required: false,
        minLength: "",
        maxLength: "",
        pattern: "",
        custom: "",
        customPrivate: false
      },
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      type: "textfield",
      labelPosition: "top",
      inputFormat: "plain",
      tags: [],
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      inputType: "text",
      inputMask: "",
      label: "Bill State",
      key: "billState",
      placeholder: "",
      prefix: "",
      suffix: "",
      multiple: false,
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      spellcheck: true,
      validate: {
        required: false,
        minLength: "",
        maxLength: "",
        pattern: "",
        custom: "",
        customPrivate: false
      },
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      type: "textfield",
      labelPosition: "top",
      inputFormat: "plain",
      tags: [],
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      inputType: "text",
      inputMask: "",
      label: "Bill Zip Code",
      key: "billZipcode",
      placeholder: "",
      prefix: "",
      suffix: "",
      multiple: false,
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      spellcheck: true,
      validate: {
        required: false,
        minLength: "",
        maxLength: "",
        pattern: "",
        custom: "",
        customPrivate: false
      },
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      type: "textfield",
      labelPosition: "top",
      inputFormat: "plain",
      tags: [],
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      inputType: "text",
      inputMask: "",
      label: "Country",
      key: "shipCountry",
      placeholder: "",
      prefix: "",
      suffix: "",
      multiple: false,
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      spellcheck: true,
      validate: {
        required: false,
        minLength: "",
        maxLength: "",
        pattern: "",
        custom: "",
        customPrivate: false
      },
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      type: "textfield",
      labelPosition: "top",
      inputFormat: "plain",
      tags: [],
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      inputType: "text",
      inputMask: "",
      label: "Product ID",
      key: "productID",
      placeholder: "",
      prefix: "",
      suffix: "",
      multiple: false,
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      spellcheck: true,
      validate: {
        required: false,
        minLength: "",
        maxLength: "",
        pattern: "",
        custom: "",
        customPrivate: false
      },
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      type: "textfield",
      labelPosition: "top",
      inputFormat: "plain",
      tags: [],
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      inputType: "text",
      inputMask: "",
      label: "Product IDs",
      key: "productIDs",
      placeholder: "",
      prefix: "",
      suffix: "",
      multiple: false,
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      spellcheck: true,
      validate: {
        required: false,
        minLength: "",
        maxLength: "",
        pattern: "",
        custom: "",
        customPrivate: false
      },
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      type: "textfield",
      labelPosition: "top",
      inputFormat: "plain",
      tags: [],
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      inputType: "text",
      inputMask: "",
      label: "Description",
      key: "productDescription",
      placeholder: "",
      prefix: "",
      suffix: "",
      multiple: false,
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      spellcheck: true,
      validate: {
        required: false,
        minLength: "",
        maxLength: "",
        pattern: "",
        custom: "",
        customPrivate: false
      },
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      type: "textfield",
      labelPosition: "top",
      inputFormat: "plain",
      tags: [],
      properties: {},
      hideLabel: false,
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      inputType: "text",
      inputMask: "",
      label: "Description",
      key: "Description",
      placeholder: "",
      prefix: "",
      suffix: "",
      multiple: false,
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      spellcheck: true,
      validate: {
        required: false,
        minLength: "",
        maxLength: "",
        pattern: "",
        custom: "",
        customPrivate: false
      },
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      type: "textfield",
      labelPosition: "top",
      inputFormat: "plain",
      tags: [],
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Vendor",
      key: "vendor",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: ""
      },
      dataSrc: "values",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Vendors",
      key: "vendors",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: 'values = data["vendorValues"]'
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "Show Inactive",
      dataGridLabel: false,
      key: "vendorsShowInactive",
      defaultValue: false,
      protected: false,
      persistent: true,
      hidden: false,
      name: "",
      value: "",
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "checkbox",
      labelPosition: "right",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {},
      lockKey: true,
      hideLabel: false
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Brand",
      key: "brands",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: "values = data['vendorValues']"
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Product Line",
      key: "productLines",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: 'values = data["productLineValues"]'
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "CustomSource1",
      key: "customSource1",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: 'values = data["customSource1Values"]'
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Categories",
      key: "categories",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: 'values = data["categoryValues"]'
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Product Categories",
      key: "productCategories",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: 'values = data["categoryValues"]'
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Account Type",
      key: "accountType",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: "values = data['accountTypeValues']"
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Location Type",
      key: "locationType",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: "values = data['locationTypeValues']"
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Source",
      key: "customerSources",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: "values = data['customerSourcesValues']"
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Product Sub Categories",
      key: "productSubCategories",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: 'values = data["subcategoryValues"]'
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Sub Category",
      key: "subcategories",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: 'values = data["subcategoryValues"]'
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Super Category",
      key: "supercategories",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: 'values = data["supercategoryValues"]'
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Collections",
      key: "collections",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: 'values = data["subCategoryValues"]'
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Warehouse",
      key: "warehouses",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: 'values = data["warehouseValues"]'
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Factory",
      key: "factory",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: 'values = data["warehouseValues"]'
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Statuses",
      key: "statuses",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: "values = data['orderStatusValues']"
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Promotions",
      key: "promoCodes",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: "values = data['promotionValues']"
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.value }} - {{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Statuses",
      key: "customerStatuses",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: "values = data['customerStatusValues']"
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Rep Type",
      key: "repType",
      placeholder: "",
      data: {
        values: [
          {
            value: "currentRep",
            label: "Current"
          },
          {
            value: "territoryRep",
            label: "PaidRep"
          },
          {
            value: "writingRep",
            label: "Writing"
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: ""
      },
      dataSrc: "values",
      valueProperty: "",
      defaultValue: "currentRep",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Sales Rep",
      key: "repID",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: "values = data['salesRepValues']"
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }} - {{item.value }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Terms",
      key: "terms",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: "values = data['termsValues']"
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Rep Group",
      key: "repGroup",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: "values = data['repGroupValues']"
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Region",
      key: "region",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: "values = data['regionValues']"
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      inputType: "text",
      inputMask: "",
      label: "Corporate",
      key: "billTos",
      placeholder: "",
      prefix: "",
      suffix: "",
      multiple: false,
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      spellcheck: true,
      validate: {
        required: false,
        minLength: "",
        maxLength: "",
        pattern: "",
        custom: "",
        customPrivate: false
      },
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      type: "textfield",
      labelPosition: "top",
      inputFormat: "plain",
      tags: [],
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Price List",
      key: "priceList",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: 'values = data["priceListValues"]'
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      inputType: "text",
      inputMask: "",
      label: "Shipping",
      key: "shipTos",
      placeholder: "",
      prefix: "",
      suffix: "",
      multiple: false,
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      spellcheck: true,
      validate: {
        required: false,
        minLength: "",
        maxLength: "",
        pattern: "",
        custom: "",
        customPrivate: false
      },
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      type: "textfield",
      labelPosition: "top",
      inputFormat: "plain",
      tags: [],
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Start Date",
      key: "startDate",
      placeholder: "",
      format: "yyyy-MM-dd",
      enableDate: true,
      enableTime: false,
      defaultDate: "",
      datepickerMode: "day",
      datePicker: {
        showWeeks: true,
        startingDay: 0,
        initDate: "",
        minMode: "day",
        maxMode: "year",
        yearRows: 4,
        yearColumns: 5,
        minDate: null,
        maxDate: null,
        datepickerMode: "day"
      },
      timePicker: {
        hourStep: 1,
        minuteStep: 1,
        showMeridian: true,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true
      },
      protected: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false,
        custom: ""
      },
      type: "datetime",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "End Date",
      key: "endDate",
      placeholder: "",
      format: "yyyy-MM-dd",
      enableDate: true,
      enableTime: false,
      defaultDate: "",
      datepickerMode: "day",
      datePicker: {
        showWeeks: true,
        startingDay: 0,
        initDate: "",
        minMode: "day",
        maxMode: "year",
        yearRows: 4,
        yearColumns: 5,
        minDate: null,
        maxDate: null,
        datepickerMode: "day"
      },
      timePicker: {
        hourStep: 1,
        minuteStep: 1,
        showMeridian: true,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true
      },
      protected: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false,
        custom: ""
      },
      type: "datetime",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Start Date 2",
      key: "startDate2",
      placeholder: "",
      format: "yyyy-MM-dd",
      enableDate: true,
      enableTime: false,
      defaultDate: "",
      datepickerMode: "day",
      datePicker: {
        showWeeks: true,
        startingDay: 0,
        initDate: "",
        minMode: "day",
        maxMode: "year",
        yearRows: 4,
        yearColumns: 5,
        minDate: null,
        maxDate: null,
        datepickerMode: "day"
      },
      timePicker: {
        hourStep: 1,
        minuteStep: 1,
        showMeridian: true,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true
      },
      protected: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false,
        custom: ""
      },
      type: "datetime",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "End Date 2",
      key: "endDate2",
      placeholder: "",
      format: "yyyy-MM-dd",
      enableDate: true,
      enableTime: false,
      defaultDate: "",
      datepickerMode: "day",
      datePicker: {
        showWeeks: true,
        startingDay: 0,
        initDate: "",
        minMode: "day",
        maxMode: "year",
        yearRows: 4,
        yearColumns: 5,
        minDate: null,
        maxDate: null,
        datepickerMode: "day"
      },
      timePicker: {
        hourStep: 1,
        minuteStep: 1,
        showMeridian: true,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true
      },
      protected: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false,
        custom: ""
      },
      type: "datetime",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Ship Start Date",
      key: "shipStartDate",
      placeholder: "",
      format: "yyyy-MM-dd",
      enableDate: true,
      enableTime: false,
      defaultDate: "",
      datepickerMode: "day",
      datePicker: {
        showWeeks: true,
        startingDay: 0,
        initDate: "",
        minMode: "day",
        maxMode: "year",
        yearRows: 4,
        yearColumns: 5,
        minDate: null,
        maxDate: null,
        datepickerMode: "day"
      },
      timePicker: {
        hourStep: 1,
        minuteStep: 1,
        showMeridian: true,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true
      },
      protected: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false,
        custom: ""
      },
      type: "datetime",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Ship End Date",
      key: "shipEndDate",
      placeholder: "",
      format: "yyyy-MM-dd",
      enableDate: true,
      enableTime: false,
      defaultDate: "",
      datepickerMode: "day",
      datePicker: {
        showWeeks: true,
        startingDay: 0,
        initDate: "",
        minMode: "day",
        maxMode: "year",
        yearRows: 4,
        yearColumns: 5,
        minDate: null,
        maxDate: null,
        datepickerMode: "day"
      },
      timePicker: {
        hourStep: 1,
        minuteStep: 1,
        showMeridian: true,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true
      },
      protected: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false,
        custom: ""
      },
      type: "datetime",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Customer Created Start Date",
      key: "customerCreatedStartDate",
      placeholder: "",
      format: "yyyy-MM-dd",
      enableDate: true,
      enableTime: false,
      defaultDate: "",
      datepickerMode: "day",
      datePicker: {
        showWeeks: true,
        startingDay: 0,
        initDate: "",
        minMode: "day",
        maxMode: "year",
        yearRows: 4,
        yearColumns: 5,
        minDate: null,
        maxDate: null,
        datepickerMode: "day"
      },
      timePicker: {
        hourStep: 1,
        minuteStep: 1,
        showMeridian: true,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true
      },
      protected: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false,
        custom: ""
      },
      type: "datetime",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Customer Created End Date",
      key: "customerCreatedEndDate",
      placeholder: "",
      format: "yyyy-MM-dd",
      enableDate: true,
      enableTime: false,
      defaultDate: "",
      datepickerMode: "day",
      datePicker: {
        showWeeks: true,
        startingDay: 0,
        initDate: "",
        minMode: "day",
        maxMode: "year",
        yearRows: 4,
        yearColumns: 5,
        minDate: null,
        maxDate: null,
        datepickerMode: "day"
      },
      timePicker: {
        hourStep: 1,
        minuteStep: 1,
        showMeridian: true,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true
      },
      protected: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false,
        custom: ""
      },
      type: "datetime",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Customer First Order Start Date",
      key: "customerFirstOrderStartDate",
      placeholder: "",
      format: "yyyy-MM-dd",
      enableDate: true,
      enableTime: false,
      defaultDate: "",
      datepickerMode: "day",
      datePicker: {
        showWeeks: true,
        startingDay: 0,
        initDate: "",
        minMode: "day",
        maxMode: "year",
        yearRows: 4,
        yearColumns: 5,
        minDate: null,
        maxDate: null,
        datepickerMode: "day"
      },
      timePicker: {
        hourStep: 1,
        minuteStep: 1,
        showMeridian: true,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true
      },
      protected: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false,
        custom: ""
      },
      type: "datetime",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Customer First Order End Date",
      key: "customerFirstOrderEndDate",
      placeholder: "",
      format: "yyyy-MM-dd",
      enableDate: true,
      enableTime: false,
      defaultDate: "",
      datepickerMode: "day",
      datePicker: {
        showWeeks: true,
        startingDay: 0,
        initDate: "",
        minMode: "day",
        maxMode: "year",
        yearRows: 4,
        yearColumns: 5,
        minDate: null,
        maxDate: null,
        datepickerMode: "day"
      },
      timePicker: {
        hourStep: 1,
        minuteStep: 1,
        showMeridian: true,
        readonlyInput: false,
        mousewheel: true,
        arrowkeys: true
      },
      protected: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false,
        custom: ""
      },
      type: "datetime",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Order Status",
      key: "orderStatuses",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: "values = data['orderStatusValues']"
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "ERP Statuses",
      key: "erpStatuses",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: "values = data['erpStatusValues']"
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Transaction Types",
      key: "transactionTypes",
      placeholder: "",
      data: {
        values: [
          {
            value: "Order",
            label: "Order"
          },
          {
            value: "Quote",
            label: "Quote"
          },
          {
            value: "Sample",
            label: "Sample"
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: ""
      },
      dataSrc: "values",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Line Statuses",
      key: "lineStatuses",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: "values = data['lineStatusValues']"
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Order Source",
      key: "orderSource",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: "values = data['orderSourceValues']"
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Order Type",
      key: "transactionType",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: "values = data['transactionTypeValues']"
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Show Code",
      key: "showCode",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: "values = data['showCodeValues']"
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      inputType: "text",
      inputMask: "",
      label: "Order Number",
      key: "orderNumber",
      placeholder: "",
      prefix: "",
      suffix: "",
      multiple: false,
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      spellcheck: true,
      validate: {
        required: false,
        minLength: "",
        maxLength: "",
        pattern: "",
        custom: "",
        customPrivate: false
      },
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      type: "textfield",
      labelPosition: "top",
      inputFormat: "plain",
      tags: [],
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      inputType: "text",
      inputMask: "",
      label: "PO Number",
      key: "poNumber",
      placeholder: "",
      prefix: "",
      suffix: "",
      multiple: false,
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      spellcheck: true,
      validate: {
        required: false,
        minLength: "",
        maxLength: "",
        pattern: "",
        custom: "",
        customPrivate: false
      },
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      type: "textfield",
      labelPosition: "top",
      inputFormat: "plain",
      tags: [],
      properties: {},
      hideLabel: false
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Activity Type",
      key: "activityType",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: "values = data['activityTypeValues']"
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Format",
      key: "format",
      placeholder: "",
      data: {
        values: [
          {
            value: "Summary",
            label: "Summary"
          },
          {
            value: "Details",
            label: "Details"
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: ""
      },
      dataSrc: "values",
      valueProperty: "",
      defaultValue: "Summary",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Stock",
      key: "inStock",
      placeholder: "",
      data: {
        values: [
          {
            value: "all",
            label: "All"
          },
          {
            value: "In",
            label: "In Stock"
          },
          {
            value: "Out",
            label: "Out of Stock"
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: ""
      },
      dataSrc: "values",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Transaction Type",
      key: "source",
      placeholder: "",
      data: {
        values: [
          {
            value: "SalesOrders",
            label: "Sales Orders"
          },
          {
            value: "invoices",
            label: "Invoices"
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: ""
      },
      dataSrc: "values",
      valueProperty: "",
      defaultValue: "SalesOrders",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Invoice Type",
      key: "invoiceType",
      placeholder: "",
      data: {
        values: [
          {
            value: "All",
            label: "All"
          },
          {
            value: "Invoice",
            label: "Invoice"
          },
          {
            value: "CreditMemo",
            label: "CreditMemo"
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: ""
      },
      dataSrc: "values",
      valueProperty: "",
      defaultValue: "All",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Customer Category",
      key: "customerCategory",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: 'values = data["customerCategoryValues"]'
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: true,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Top",
      key: "top",
      placeholder: "",
      data: {
        values: [
          {
            value: "0",
            label: "All"
          },
          {
            value: "10",
            label: "10"
          },
          {
            value: "25",
            label: "25"
          },
          {
            value: "50",
            label: "50"
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: ""
      },
      dataSrc: "values",
      valueProperty: "",
      defaultValue: "All",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Sort By",
      key: "sortBy",
      placeholder: "",
      data: {
        values: [
          {
            value: "Qty",
            label: "Qty"
          },
          {
            value: "Total",
            label: "Total"
          },
          {
            value: "SKU",
            label: "SKU"
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: ""
      },
      dataSrc: "values",
      valueProperty: "",
      defaultValue: "Qty",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Printed In Warehouse",
      key: "printedInWarehouse",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          },
          {
            value: "YES",
            label: "YES"
          },
          {
            value: "",
            label: "NO"
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: ''
      },
      dataSrc: "values",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Order Options",
      key: "orderOptions",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: 'values = data["orderOptionsValues"]'
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Date Range",
      key: "dateRange",
      placeholder: "",
      data: {
        values: [
          {
            value: "FYTD",
            label: "FYTD"
          },
          {
            value: "FMTD",
            label: "FMTD"
          },
          {
            value: "YTD",
            label: "YTD"
          },
          {
            value: "MTD",
            label: "MTD"
          },
          {
            value: "3M",
            label: "3M"
          },
          {
            value: "6M",
            label: "6M"
          },
          {
            value: "9M",
            label: "9M"
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: ""
      },
      dataSrc: "values",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Report",
      key: "repPerformanceRange",
      placeholder: "",
      data: {
        values: [
          {
            value: "MTD",
            label: "MTD"
          },
          {
            value: "YTD",
            label: "YTD"
          },
          {
            value: "Last12",
            label: "Last 12 Months"
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: ""
      },
      dataSrc: "values",
      valueProperty: "",
      defaultValue: "MTD",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Layout",
      key: "photoSheetLayout",
      placeholder: "",
      data: {
        values: [
          {
            value: "2x2",
            label: "2x2"
          },
          {
            value: "5x3",
            label: "5x3"
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: ""
      },
      dataSrc: "values",
      valueProperty: "",
      defaultValue: "2x2",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Data Analysis Reports",
      key: "dataAnalysisReports",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: "values = data['dataAnalysisReportsValues']"
      },
      dataSrc: "custom",
      valueProperty: "value",
      defaultValue: "ByCustomer",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Location",
      key: "location",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: "values = data['locationValues']"
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      inputType: "text",
      inputMask: "",
      label: "Product Tags",
      key: "productTags",
      placeholder: "",
      prefix: "",
      suffix: "",
      multiple: false,
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      spellcheck: true,
      validate: {
        required: false,
        minLength: "",
        maxLength: "",
        pattern: "",
        custom: "",
        customPrivate: false
      },
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      type: "textfield",
      labelPosition: "top",
      inputFormat: "plain",
      tags: [],
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "Report by Paid Sales",
      dataGridLabel: false,
      key: "reportByPaidSales",
      defaultValue: "true",
      protected: false,
      persistent: true,
      hidden: false,
      name: "",
      value: "",
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "checkbox",
      labelPosition: "right",
      hideLabel: false,
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "Group by Vendor",
      dataGridLabel: false,
      key: "groupbyVendor",
      defaultValue: "true",
      protected: false,
      persistent: true,
      hidden: false,
      name: "",
      value: "",
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "checkbox",
      labelPosition: "right",
      hideLabel: false,
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "Group by Brand Group",
      dataGridLabel: false,
      key: "groupbyBrandGroup",
      defaultValue: "true",
      protected: false,
      persistent: true,
      hidden: false,
      name: "",
      value: "",
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "checkbox",
      labelPosition: "right",
      hideLabel: false,
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "Group by Brand",
      dataGridLabel: false,
      key: "groupbyBrand",
      defaultValue: "false",
      protected: false,
      persistent: true,
      hidden: false,
      name: "",
      value: "",
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "checkbox",
      labelPosition: "right",
      hideLabel: false,
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "Group by Division",
      dataGridLabel: false,
      key: "groupByDivision",
      defaultValue: "false",
      protected: false,
      persistent: true,
      hidden: false,
      name: "",
      value: "",
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "checkbox",
      labelPosition: "right",
      hideLabel: false,
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "Group by Region",
      dataGridLabel: false,
      key: "groupByRegion",
      defaultValue: "false",
      protected: false,
      persistent: true,
      hidden: false,
      name: "",
      value: "",
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "checkbox",
      labelPosition: "right",
      hideLabel: false,
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "Group by Paid Rep",
      dataGridLabel: false,
      key: "groupByPaidRep",
      defaultValue: "false",
      protected: false,
      persistent: true,
      hidden: false,
      name: "",
      value: "",
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "checkbox",
      labelPosition: "right",
      hideLabel: false,
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "Group by Sales Rep",
      dataGridLabel: false,
      key: "groupBySalesRep",
      defaultValue: "false",
      protected: false,
      persistent: true,
      hidden: false,
      name: "",
      value: "",
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "checkbox",
      labelPosition: "right",
      hideLabel: false,
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "Group by Parent Vendor",
      dataGridLabel: false,
      key: "groupByParentVendor",
      defaultValue: "false",
      protected: false,
      persistent: true,
      hidden: false,
      name: "",
      value: "",
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "checkbox",
      labelPosition: "right",
      hideLabel: false,
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "Group by Parent Customer",
      dataGridLabel: false,
      key: "groupByParentCustomer",
      defaultValue: "false",
      protected: false,
      persistent: true,
      hidden: false,
      name: "",
      value: "",
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "checkbox",
      labelPosition: "right",
      hideLabel: false,
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "Group by Ship To",
      dataGridLabel: false,
      key: "groupbyShipTo",
      defaultValue: false,
      protected: false,
      persistent: true,
      hidden: false,
      name: "",
      value: "",
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "checkbox",
      labelPosition: "right",
      hideLabel: false,
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "Exported",
      dataGridLabel: false,
      key: "exported",
      defaultValue: "true",
      protected: false,
      persistent: true,
      hidden: false,
      name: "",
      value: "",
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "checkbox",
      labelPosition: "right",
      hideLabel: false,
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "Group by Customer",
      dataGridLabel: false,
      key: "groupbyCustomer",
      defaultValue: false,
      protected: false,
      persistent: true,
      hidden: false,
      name: "",
      value: "",
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "checkbox",
      labelPosition: "right",
      hideLabel: false,
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "Group by Rep",
      dataGridLabel: false,
      key: "groupbyRep",
      defaultValue: false,
      protected: false,
      persistent: true,
      hidden: false,
      name: "",
      value: "",
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "checkbox",
      labelPosition: "right",
      hideLabel: false,
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "Include Images",
      dataGridLabel: false,
      key: "includeImages",
      defaultValue: false,
      protected: false,
      persistent: true,
      hidden: false,
      name: "",
      value: "",
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "checkbox",
      labelPosition: "right",
      hideLabel: false,
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "Inside Sales Only",
      dataGridLabel: false,
      key: "insideSalesAll",
      defaultValue: false,
      protected: false,
      persistent: true,
      hidden: false,
      name: "",
      value: "",
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "checkbox",
      labelPosition: "right",
      hideLabel: false,
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "Group by sub-category",
      dataGridLabel: false,
      key: "groupBySubCategory",
      defaultValue: "true",
      protected: false,
      persistent: true,
      hidden: false,
      name: "",
      value: "",
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "checkbox",
      labelPosition: "right",
      hideLabel: false,
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "Hide Price",
      dataGridLabel: false,
      key: "hidePrice",
      defaultValue: "false",
      protected: false,
      persistent: true,
      hidden: false,
      name: "",
      value: "",
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "checkbox",
      labelPosition: "right",
      hideLabel: false,
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "In Stock Only",
      dataGridLabel: false,
      key: "inStockOnly",
      defaultValue: "false",
      protected: false,
      persistent: true,
      hidden: false,
      name: "",
      value: "",
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "checkbox",
      labelPosition: "right",
      hideLabel: false,
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      inputType: "checkbox",
      tableView: true,
      label: "Hide Inventory",
      dataGridLabel: false,
      key: "hideInventory",
      defaultValue: "false",
      protected: false,
      persistent: true,
      hidden: false,
      name: "",
      value: "",
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "checkbox",
      labelPosition: "right",
      hideLabel: false,
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      inputType: "text",
      inputMask: "",
      label: "State",
      key: "State",
      placeholder: "",
      prefix: "",
      suffix: "",
      multiple: false,
      defaultValue: "",
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      spellcheck: true,
      validate: {
        required: false,
        minLength: "",
        maxLength: "",
        pattern: "",
        custom: "",
        customPrivate: false
      },
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      type: "textfield",
      labelPosition: "top",
      inputFormat: "plain",
      tags: [],
      properties: {},
      lockKey: true
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Document Type",
      key: "DocType",
      placeholder: "",
      data: {
        values: [
          {
            value: "",
            label: ""
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: "values = data['docTypeValues']"
      },
      dataSrc: "custom",
      valueProperty: "",
      defaultValue: "",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      tableView: true,
      label: "Output",
      key: "output",
      placeholder: "",
      data: {
        values: [
          {
            value: "pdf",
            label: "pdf"
          },
          {
            value: "xlsx",
            label: "xlsx"
          }
        ],
        json: "",
        url: "",
        resource: "",
        custom: ""
      },
      dataSrc: "values",
      valueProperty: "",
      defaultValue: "xlsx",
      refreshOn: "",
      filter: "",
      authenticate: false,
      template: "<span>{{ item.label }}</span>",
      multiple: false,
      protected: false,
      unique: false,
      persistent: true,
      hidden: false,
      clearOnHide: true,
      validate: {
        required: false
      },
      type: "select",
      labelPosition: "top",
      tags: [],
      conditional: {
        show: "",
        when: null,
        eq: ""
      },
      properties: {}
    },
    {
      autofocus: false,
      input: true,
      label: "Submit",
      tableView: false,
      key: "submit",
      size: "md",
      leftIcon: "",
      rightIcon: "",
      block: false,
      action: "submit",
      disableOnInvalid: false,
      theme: "primary",
      type: "button"
    }
  ],
  revisions: "",
  _vid: 0,
  title: "ReportParams",
  display: "form",
  access: [
    {
      roles: [
        "5b88072cacd5b53313ad5918",
        "5b88072cacd5b5f747ad5919",
        "5b88072cacd5b55293ad591a"
      ],
      type: "read_all"
    }
  ],
  submissionAccess: [],
  settings: {},
  name: "reportParams",
  path: "reportparams",
  project: "5b88072cacd5b53c66ad5917",
  created: "2018-09-04T17:08:42.719Z",
  modified: "2019-05-07T14:31:10.620Z",
  machineName: "irlxqknnoqiregk:reportParams"
};
